<template>
  <div class="columns is-multiline is-main-content is-marginless is-paddingless"
       v-if="critereRecherche">
    <div class="column is-12 pdb-0 hauteur-haut-brief-filtre">
      <div class="column is-12 mgt-5px">
        <a @click="$emit('toggleFiltre')">
          <b-icon class="icon is-pulled-right has-text-icon-more" icon="close"></b-icon>
        </a>
        <span class="has-text-weight-bold is-size-4">
          {{ $t('listeRelanceOption.filtre.title') }}
        </span>
      </div>
      <div class="column is-12 pdt-0">
        <span class="has-text-icon-more is-size-7">
          {{ $t('listeRelanceOption.filtre.sousTitle') }}
        </span>
      </div>
    </div>
    <div class="column is-12 overflow-auto is-marginless hauteur-brief-filtre">
      <div class="columns is-marginless is-multiline">
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('listeRelanceOption.filtre.commercialRelance')"
                        v-model="commercialRelanceSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
        <div class="column is-12 pdb-0 mgt-10px">
          <user-tag-input
                        :label="$t('listeRelanceOption.filtre.commercialEnAttente')"
                        v-model="commercialEnAttenteSelected"
                        :items="listeCommercial">
          </user-tag-input>
        </div>
      </div>
    </div>
    <div class="column is-12 border-pied pdt-0 hauteur-bas-brief-filtre">
      <button
        class="button mgl-10px mgt-10px is-addOrEdit has-text-white"
        @click="appliquerCritere()"
      >{{$t('listeRelanceOption.filtre.actions.appliquer')}}</button>

      <button
        class="button border-none mgt-10px has-text-icon-more pd-10px"
        @click="viderCritere()"
      >{{$t('listeRelanceOption.filtre.actions.reinitialiser')}}</button>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import genererCritereRechercheRelanceOption from '@/services/relanceOption/genererCritereRechercheRelanceOption';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { COMMERCIAL, DIRECTEUR_COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { SET_CRITERE } from '@/store/modules/relanceOption-mutation-type';
import userTagInput from '@/components/general/tagInput/userTagInput';
import initialUsers from '@/services/general/filters/filterinitUsers';

const Parametres = createNamespacedHelpers('parametres');
const RelanceOption = createNamespacedHelpers('relanceOption');

export default {
  data() {
    return {
      critereRecherche: null,
      listeCommercial: [],
      commercialRelanceSelected: [],
      commercialEnAttenteSelected: [],
    };
  },
  components: {
    userTagInput,
  },
  computed: {
    ...RelanceOption.mapGetters({
      critereRechercheFromStore: 'criteresRecherche',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
  },
  methods: {
    ...RelanceOption.mapMutations({
      setCritereRecherche: SET_CRITERE,
    }),
    ...Parametres.mapActions({
      loadParametreUtilisateur: 'loadParametreUtilisateur',
    }),
    viderCritere() {
      this.critereRecherche = cloneDeep(genererCritereRechercheRelanceOption());
      this.commercialRelanceSelected = [];
      this.commercialEnAttenteSelected = [];
    },
    appliquerCritere() {
      this.critereRecherche.commercialRelanceIds = this.commercialRelanceSelected.map((c) => {
        return c.id;
      });
      this.critereRecherche.commercialRelanceurIds = this.commercialEnAttenteSelected.map((c) => {
        return c.id;
      });
      this.setCritereRecherche(this.critereRecherche);
      this.$emit('recherche');
    },
    async initializeFiltre() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        this.critereRecherche = cloneDeep(this.critereRechercheFromStore);
        await this.loadParametreUtilisateur();

        const users = this.parametre(PARAMETRES_KEYS.utilisateur)
          .filter(u => u.actif);
        this.listeCommercial = initialUsers(users, [DIRECTEUR_COMMERCIAL, COMMERCIAL]);

        this.commercialRelanceSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialRelanceIds.includes(c.id);
        });
        this.commercialEnAttenteSelected = this.listeCommercial.filter((c) => {
          return this.critereRecherche.commercialRelanceurIds.includes(c.id);
        });
        loadingComponent.close();
      } catch (e) {
        messageErreur(this.$i18n);
        loadingComponent.close();
        throw e;
      }
    },
  },
  mounted() {
    this.initializeFiltre();
  },
};
</script>
